import { render, staticRenderFns } from "./ximg.vue?vue&type=template&id=a67e29be&"
import script from "./ximg.vue?vue&type=script&lang=js&"
export * from "./ximg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports